<div class="page-layout carded fullwidth inner-scroll">
    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <div class="center" style="width: 100%;">
        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
        </div>
        <!-- / CONTENT HEADER -->
        <!-- CONTENT CARD -->
        <div class="content-card " style="border-color: transparent">
            <img src="./assets/images/norm35/Mesa de trabajo 7.png" alt="Logo-Norm35" class="centradoIMG ">

            <div class="container" style="padding-left: 5%; padding-right: 5%; padding-top: 2%;">
                <div *ngFor="let datita of dataStep7_inf">
                    <span *ngIf=" dataId.id == datita.position ">{{datita.tittle}}</span>

                    <div *ngIf=" dataId.id == datita.position ">
                        <ul *ngFor="let submenu of datita.subInd">
                            <a target="_blank" href="./NOM35/wizard/{{submenu.ruta}}">{{submenu.info}}</a>
                        </ul>

                    </div>

                </div>


            </div>
            <!-- / CONTENT TOOLBAR -->
        </div>
        <!-- / CONTENT -->
    </div><br><br><br><br><br>
    <div class="content-card" style="margin-top: 2%; margin-left: 15%; margin-right: 15%;">

    </div>
</div>
